import type { ApiError } from '@common/api/graphql/apolloClient';
import type { QueryApiAllowedIp } from '@common/api/graphql/getProjectsGql';
import { createMessage } from '@common/api/graphql/successMessage';
import { updateApiAllowedIp } from '@common/api/graphql/updateApiAllowedIpGql';
import {
  updateApiAllowedIpFailure,
  updateApiAllowedIpStart,
  updateApiAllowedIpSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';
import handleApiErrorIfNeeded from './handleApiErrorIfNeeded';

export const updateApiAllowedIpSuccessThunk =
  (): AppThunkAction<Promise<void>> => dispatch => {
    dispatch(
      updateApiAllowedIpSuccess(createMessage('許可済みIPアドレスを更新'))
    );
    return Promise.resolve();
  };

export const updateApiAllowedIpFailureThunk =
  (error: ApiError): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(updateApiAllowedIpFailure());
    return dispatch(handleApiErrorIfNeeded(error));
  };

export const updateApiAllowedIpThunk =
  (
    projectUrlCode: UrlCode,
    apiAllowedIp: QueryApiAllowedIp
  ): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(updateApiAllowedIpStart());

    return updateApiAllowedIp(projectUrlCode, apiAllowedIp)
      .then(() => dispatch(updateApiAllowedIpSuccessThunk()))
      .catch((error: ApiError) =>
        dispatch(updateApiAllowedIpFailureThunk(error))
      );
  };
